/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { OrderEventLogDtoModel, OrderEventLogDtoModelType } from "./OrderEventLogDtoModel"
import { OrderEventLogDtoModelSelector } from "./OrderEventLogDtoModel.base"
import { OrderTagDtoModel, OrderTagDtoModelType } from "./OrderTagDtoModel"
import { OrderTagDtoModelSelector } from "./OrderTagDtoModel.base"
import { PackageDtoModel, PackageDtoModelType } from "./PackageDtoModel"
import { PackageDtoModelSelector } from "./PackageDtoModel.base"
import { RatingDtoModel, RatingDtoModelType } from "./RatingDtoModel"
import { RatingDtoModelSelector } from "./RatingDtoModel.base"
import { RouteSolutionDtoModel, RouteSolutionDtoModelType } from "./RouteSolutionDtoModel"
import { RouteSolutionDtoModelSelector } from "./RouteSolutionDtoModel.base"
import { SolutionUnscheduledDtoModel, SolutionUnscheduledDtoModelType } from "./SolutionUnscheduledDtoModel"
import { SolutionUnscheduledDtoModelSelector } from "./SolutionUnscheduledDtoModel.base"
import { VisitLoadDtoModel, VisitLoadDtoModelType } from "./VisitLoadDtoModel"
import { VisitLoadDtoModelSelector } from "./VisitLoadDtoModel.base"
import { VisitLocationDtoModel, VisitLocationDtoModelType } from "./VisitLocationDtoModel"
import { VisitLocationDtoModelSelector } from "./VisitLocationDtoModel.base"
import { VisitTimeWindowDtoModel, VisitTimeWindowDtoModelType } from "./VisitTimeWindowDtoModel"
import { VisitTimeWindowDtoModelSelector } from "./VisitTimeWindowDtoModel.base"
import { CreationSourceEnumType } from "./CreationSourceEnum"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  loads: IObservableArray<VisitLoadDtoModelType>;
  locations: IObservableArray<VisitLocationDtoModelType>;
  timeWindows: IObservableArray<VisitTimeWindowDtoModelType>;
  unscheduledReason: SolutionUnscheduledDtoModelType;
  scheduledEvent: RouteSolutionDtoModelType;
}

/**
 * VisitDtoBase
 * auto generated base class for the model VisitDtoModel.
 */
export const VisitDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('VisitDto')
  .props({
    __typename: types.optional(types.literal("VisitDto"), "VisitDto"),
    id: types.identifier,
    name: types.union(types.undefined, types.null, types.string),
    projectId: types.union(types.undefined, types.number),
    email: types.union(types.undefined, types.null, types.string),
    phone: types.union(types.undefined, types.null, types.string),
    load: types.union(types.undefined, types.null, types.number),
    loads: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => VisitLoadDtoModel)))),
    duration: types.union(types.undefined, types.null, types.number),
    isPriority: types.union(types.undefined, types.null, types.boolean),
    instructions: types.union(types.undefined, types.null, types.string),
    startDate: types.union(types.undefined, types.null, types.string),
    endDate: types.union(types.undefined, types.null, types.string),
    deliveryDate: types.union(types.undefined, types.null, types.string),
    createdOn: types.union(types.undefined, types.string),
    attempts: types.union(types.undefined, types.null, types.array(types.late((): any => OrderEventLogDtoModel))),
    logs: types.union(types.undefined, types.null, types.array(types.late((): any => OrderEventLogDtoModel))),
    locations: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => VisitLocationDtoModel)))),
    timeWindows: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => VisitTimeWindowDtoModel)))),
    packages: types.union(types.undefined, types.null, types.array(types.late((): any => PackageDtoModel))),
    isScheduled: types.union(types.undefined, types.null, types.boolean),
    scheduledOnce: types.union(types.undefined, types.null, types.boolean),
    isScheduling: types.union(types.undefined, types.null, types.boolean),
    pendingTargetRouteUuid: types.union(types.undefined, types.null, types.string),
    isUnscheduling: types.union(types.undefined, types.null, types.boolean),
    isDeleting: types.union(types.undefined, types.null, types.boolean),
    lockedActionUuid: types.union(types.undefined, types.null, types.string),
    uuid: types.union(types.undefined, types.string),
    isCompleted: types.union(types.undefined, types.null, types.boolean),
    isLocked: types.union(types.undefined, types.null, types.boolean),
    unscheduledReason: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => SolutionUnscheduledDtoModel))),
    eventUuid: types.union(types.undefined, types.null, types.string),
    customFields: types.union(types.undefined, types.null, types.frozen()),
    displayOrderId: types.union(types.undefined, types.null, types.string),
    customerOrderNumber: types.union(types.undefined, types.null, types.string),
    externalId: types.union(types.undefined, types.null, types.string),
    creationSource: types.union(types.undefined, types.null, CreationSourceEnumType),
    routificOrderNumber: types.union(types.undefined, types.null, types.string),
    customerId: types.union(types.undefined, types.null, types.string),
    /** Fields whose value was filled from the linked customer profile */
    customerFilledFields: types.union(types.undefined, types.null, types.array(types.string)),
    tags: types.union(types.undefined, types.null, types.array(types.late((): any => OrderTagDtoModel))),
    rating: types.union(types.undefined, types.null, types.late((): any => RatingDtoModel)),
    scheduledEvent: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => RouteSolutionDtoModel))),
    isDateMismatched: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class VisitDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get name() { return this.__attr(`name`) }
  get projectId() { return this.__attr(`projectId`) }
  get email() { return this.__attr(`email`) }
  get phone() { return this.__attr(`phone`) }
  get load() { return this.__attr(`load`) }
  get duration() { return this.__attr(`duration`) }
  get isPriority() { return this.__attr(`isPriority`) }
  get instructions() { return this.__attr(`instructions`) }
  get startDate() { return this.__attr(`startDate`) }
  get endDate() { return this.__attr(`endDate`) }
  get deliveryDate() { return this.__attr(`deliveryDate`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get isScheduled() { return this.__attr(`isScheduled`) }
  get scheduledOnce() { return this.__attr(`scheduledOnce`) }
  get isScheduling() { return this.__attr(`isScheduling`) }
  get pendingTargetRouteUuid() { return this.__attr(`pendingTargetRouteUuid`) }
  get isUnscheduling() { return this.__attr(`isUnscheduling`) }
  get isDeleting() { return this.__attr(`isDeleting`) }
  get lockedActionUuid() { return this.__attr(`lockedActionUuid`) }
  get uuid() { return this.__attr(`uuid`) }
  get isCompleted() { return this.__attr(`isCompleted`) }
  get isLocked() { return this.__attr(`isLocked`) }
  get eventUuid() { return this.__attr(`eventUuid`) }
  get customFields() { return this.__attr(`customFields`) }
  get displayOrderId() { return this.__attr(`displayOrderId`) }
  get customerOrderNumber() { return this.__attr(`customerOrderNumber`) }
  get externalId() { return this.__attr(`externalId`) }
  get creationSource() { return this.__attr(`creationSource`) }
  get routificOrderNumber() { return this.__attr(`routificOrderNumber`) }
  get customerId() { return this.__attr(`customerId`) }
  get customerFilledFields() { return this.__attr(`customerFilledFields`) }
  get isDateMismatched() { return this.__attr(`isDateMismatched`) }
  loads(builder: string | VisitLoadDtoModelSelector | ((selector: VisitLoadDtoModelSelector) => VisitLoadDtoModelSelector) | undefined) { return this.__child(`loads`, VisitLoadDtoModelSelector, builder) }
  attempts(builder: string | OrderEventLogDtoModelSelector | ((selector: OrderEventLogDtoModelSelector) => OrderEventLogDtoModelSelector) | undefined) { return this.__child(`attempts`, OrderEventLogDtoModelSelector, builder) }
  logs(builder: string | OrderEventLogDtoModelSelector | ((selector: OrderEventLogDtoModelSelector) => OrderEventLogDtoModelSelector) | undefined) { return this.__child(`logs`, OrderEventLogDtoModelSelector, builder) }
  locations(builder: string | VisitLocationDtoModelSelector | ((selector: VisitLocationDtoModelSelector) => VisitLocationDtoModelSelector) | undefined) { return this.__child(`locations`, VisitLocationDtoModelSelector, builder) }
  timeWindows(builder: string | VisitTimeWindowDtoModelSelector | ((selector: VisitTimeWindowDtoModelSelector) => VisitTimeWindowDtoModelSelector) | undefined) { return this.__child(`timeWindows`, VisitTimeWindowDtoModelSelector, builder) }
  packages(builder: string | PackageDtoModelSelector | ((selector: PackageDtoModelSelector) => PackageDtoModelSelector) | undefined) { return this.__child(`packages`, PackageDtoModelSelector, builder) }
  unscheduledReason(builder: string | SolutionUnscheduledDtoModelSelector | ((selector: SolutionUnscheduledDtoModelSelector) => SolutionUnscheduledDtoModelSelector) | undefined) { return this.__child(`unscheduledReason`, SolutionUnscheduledDtoModelSelector, builder) }
  tags(builder: string | OrderTagDtoModelSelector | ((selector: OrderTagDtoModelSelector) => OrderTagDtoModelSelector) | undefined) { return this.__child(`tags`, OrderTagDtoModelSelector, builder) }
  rating(builder: string | RatingDtoModelSelector | ((selector: RatingDtoModelSelector) => RatingDtoModelSelector) | undefined) { return this.__child(`rating`, RatingDtoModelSelector, builder) }
  scheduledEvent(builder: string | RouteSolutionDtoModelSelector | ((selector: RouteSolutionDtoModelSelector) => RouteSolutionDtoModelSelector) | undefined) { return this.__child(`scheduledEvent`, RouteSolutionDtoModelSelector, builder) }
}
export function selectFromVisitDto() {
  return new VisitDtoModelSelector()
}

export const visitDtoModelPrimitives = selectFromVisitDto().name.projectId.email.phone.load.duration.isPriority.instructions.startDate.endDate.deliveryDate.createdOn.isScheduled.scheduledOnce.isScheduling.pendingTargetRouteUuid.isUnscheduling.isDeleting.lockedActionUuid.uuid.isCompleted.isLocked.eventUuid.customFields.displayOrderId.customerOrderNumber.externalId.routificOrderNumber.customerId.customerFilledFields.isDateMismatched
